import { render, staticRenderFns } from "./OrganizationRow.vue?vue&type=template&id=7fd496d5&"
import script from "./OrganizationRow.vue?vue&type=script&lang=js&"
export * from "./OrganizationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports